/**
 * Share section: LinkedIn, X (Twitter), copy link with toast
 */
export default function share() {
    const shareEls = document.querySelectorAll('[data-share]');
    if (!shareEls.length) return;

    const getFullUrl = () => window.location.origin + window.location.pathname + window.location.search + window.location.hash;

    shareEls.forEach((shareEl) => {
        const title = shareEl.dataset.title;
        const linkedinBtn = shareEl.querySelector('[data-share-linkedin]');
        const xBtn = shareEl.querySelector('[data-share-x]');
        const copyBtn = shareEl.querySelector('[data-share-copy]');

        if (linkedinBtn) {
            linkedinBtn.addEventListener('click', (e) => {
                e.preventDefault();
                const url = getFullUrl();
                const shareUrl = `https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(url)}`;
                window.open(shareUrl, '_blank', 'noopener,noreferrer');
            });
        }

        if (xBtn) {
            xBtn.addEventListener('click', (e) => {
                e.preventDefault();
                const url = getFullUrl();
                const text = `${(title || '').trim()} ${url}`.trim();
                const shareUrl = `https://twitter.com/intent/tweet?text=${encodeURIComponent(text)}`;
                window.open(shareUrl, '_blank', 'noopener,noreferrer');
            });
        }

        if (copyBtn) {
            copyBtn.addEventListener('click', async () => {
                const url = getFullUrl();
                try {
                    await navigator.clipboard.writeText(url);
                    showToast('Link copied');
                } catch {
                    const input = document.createElement('input');
                    input.value = url;
                    document.body.appendChild(input);
                    input.select();
                    document.execCommand('copy');
                    document.body.removeChild(input);
                    showToast('Link copied');
                }
            });
        }
    });
}

function showToast(message) {
    const existing = document.querySelector('.gh-share-toast');
    if (existing) existing.remove();

    const toast = document.createElement('div');
    toast.className = 'gh-share-toast';
    toast.textContent = message;
    toast.setAttribute('role', 'status');
    toast.setAttribute('aria-live', 'polite');
    document.body.appendChild(toast);

    requestAnimationFrame(() => toast.classList.add('is-visible'));

    const hide = () => {
        toast.classList.remove('is-visible');
        setTimeout(() => toast.remove(), 300);
    };

    setTimeout(hide, 2000);
}
